import React from 'react';
import { motion } from 'framer-motion';
import { Gift, ArrowDown, Check } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { CountdownTimer } from './CountdownTimer';
export function BonusSection() {
  return <section className="py-24 px-4 bg-stone-50" data-id="element-21" data-mp="22f3edg5glho3">
      <div className="max-w-5xl mx-auto" data-id="element-22" data-mp="1yeb3yjkup6q8">
        <div className="text-center mb-16" data-id="element-23" data-mp="1yfcqplb8bhns">
          <p className="text-rose-700 font-semibold tracking-widest uppercase text-xs mb-2" data-id="element-24" data-mp="1aogsa5c9po7k">
            Included at No Extra Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-4" data-id="element-25" data-mp="15qf9zmmo1sx5">
            5 Exclusive Bonuses
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto" data-id="element-26" data-mp="1jivjn6a2op71">
            Every bonus solves a different teaching problem.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-27" data-mp="qzojqj0q31w5">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-stone-200 rounded-2xl p-8 relative flex flex-col h-full ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="mzo26pibuakv" data-mpi={index}>
              <div className={`absolute top-0 right-0 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-xs uppercase tracking-wider ${bonus.badgeClass}`} data-id="element-29" data-mp="1vu4zt6fibhbi">
                Bonus {bonus.id}
              </div>

              <div className="w-12 h-12 bg-stone-100 rounded-full flex items-center justify-center text-rose-700 mb-6" data-id="element-30" data-mp="3c5ifbh6d4wz4">
                <Gift size={22} aria-hidden="true" data-id="element-31" data-mp="3h43fxhpj1io3" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-20 text-stone-800" data-id="element-32" data-mp="1h2m1x603pfvy">
                {bonus.title}
              </h3>

              <p className="text-rose-800 text-sm font-medium mb-4" data-id="element-33" data-mp="1c42fl4hli232">
                {bonus.subtitle}
              </p>

              <div className="inline-flex items-baseline gap-x-2 bg-stone-100 border border-stone-200 px-3 py-1 rounded mb-5 self-start" data-id="element-34" data-mp="1q1qza8zxf36j">
                <span className="text-rose-700 font-bold" data-id="element-35" data-mp="yc4engy1fchz">FREE</span>
                <span className="text-stone-600 text-sm" data-id="element-36" data-mp="tdt4t67qt1zr">
                  with Makeup Instructor Ready
                </span>
              </div>

              <div className="flex-grow mb-6" data-id="element-37" data-mp="1760vcg8fnwq0">
                {bonus.lead && <p className="text-stone-600 text-sm leading-relaxed mb-3" data-id="element-38" data-mp="12e974ccr2331">
                    {bonus.lead}
                  </p>}
                <p className="text-stone-800 text-sm font-semibold mb-3" data-id="element-39" data-mp="emu046a12xlg">
                  {bonus.listLabel}
                </p>

                {bonus.flow ? <ol className="flex flex-col items-start gap-1" data-id="element-40" data-mp="imlon0s5w2k">
                    {bonus.items.map((item, i) => <li key={item} className="flex flex-col items-start" data-id="element-41" data-mp="5bfsdgft7eha" data-mpi={i}>
                        <span className="bg-stone-100 border border-stone-200 text-stone-800 text-sm rounded-lg px-3 py-1" data-id="element-42" data-mp="3mrximdsi445f">
                          {item}
                        </span>
                        {i < bonus.items.length - 1 && <ArrowDown size={14} className="text-rose-700 ml-4 my-0.5" aria-hidden="true" data-id="element-43" data-mp="o8yzufmmcp1l" />}
                      </li>)}
                  </ol> : <ul className={`grid grid-cols-2 gap-x-4 gap-y-1.5 ${index === bonuses.length - 1 ? 'md:grid-cols-4' : ''}`} data-id="element-44" data-mp="2u1nurbbdhk6d">
                    {bonus.items.map(item => <li key={item} className="flex items-start gap-1.5 text-stone-600 text-sm" data-id="element-45" data-mp="3f8y9a8vgx964">
                        <Check size={14} className="text-rose-700 shrink-0 mt-0.5" aria-hidden="true" data-id="element-46" data-mp="35htub95sloba" />
                        <span data-id="element-47" data-mp="21wmh6v3ssg4">{item}</span>
                      </li>)}
                  </ul>}

                {bonus.progression && <div className="mt-4" data-id="element-48" data-mp="3o8l2w8hyhaom">
                    <p className="text-stone-800 text-sm font-semibold mb-2" data-id="element-49" data-mp="3o7jqo0p7ei5b">
                      {bonus.progressionLabel}
                    </p>
                    <p className="bg-rose-700/10 border border-rose-700/30 text-rose-900 text-sm font-semibold rounded-lg px-3 py-2" data-id="element-50" data-mp="2ctob4que07dk">
                      {bonus.progression}
                    </p>
                  </div>}
              </div>

              <div className="mt-auto" data-id="element-51" data-mp="ne5bd23e6lcq">
                {bonus.closing.map(line => <p key={line} className="text-rose-800 text-sm italic font-medium" data-id="element-52" data-mp="scf7pg0urrzx">
                    {line}
                  </p>)}
              </div>
            </motion.article>)}
        </div>

        <CountdownTimer data-id="element-53" data-mp="16zi2vg1pdok3" />
      </div>
    </section>;
}